<template>
  <div class="app-container">

    <div class="kaipiaoInfo" >
<!--      <div style="font-size: 16px;color: #3A5372;margin-bottom: 10px">-->
<!--        <span style="width: 2px;height: 12px;background-color: #000;display: inline-block"></span> 开票信息:-->
<!--        <span style="font-size: 16px;color: #FF0101">-->
<!--          请将您的开票信息发送至 381972290@qq.com 邮箱，联系电话 18608006961-->
<!--        </span>-->
<!--      </div>-->
      <el-alert
          title="申请发票：请将您的开票信息发送至 895777194@qq.com 邮箱，技术服务热线：17780520853 "
          type="warning"
          :closable="false"
          show-icon>
      </el-alert>
    </div>

    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px" style="margin-bottom: 20px">
      <el-form-item label="订单号" prop="id">
        <el-input
            v-model="queryParams.id"
            placeholder="请输入订单号"
            clearable
            size="small"
            @keyup.enter.native="handleQuery(1)"
        />
      </el-form-item>
      <el-form-item label="支付方式" prop="payType">
        <el-select v-model="queryParams.payType" placeholder="请选择支付方式" clearable size="small">
          <el-option
              v-for="dict in payTypeOptions"
              :key="dict.label"
              :label="dict.value"
              :value="dict.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="支付状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="请选择支付状态" clearable size="small">
          <el-option
              v-for="dict in payStatusOptions"
              :key="dict.label"
              :label="dict.value"
              :value="dict.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

      <el-table v-loading="loading" :data="orderList" @selection-change="handleSelectionChange">
        <el-table-column label="订单号" align="center" prop="id" />
        <el-table-column label="用户名称" align="center" prop="userName" />
        <el-table-column label="金额" align="center" prop="amonut" width="60"/>
        <el-table-column label="支付方式" align="center" prop="payType" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.payType=='wx'">微信</span>
            <span v-if="scope.row.payType=='zfb'">支付宝</span>
            <span v-if="scope.row.payType=='yl'">银联</span>
            <span v-if="!scope.row.payType">-</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" align="center" prop="status" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='pay'"> <el-tag type="success">已支付</el-tag></span>
            <span v-if="scope.row.status=='notPay'"><el-tag type="info">未支付</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" prop="status" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.payTime"> {{ parseTime(scope.row.payTime, '{y}-{m}-{d} {h}:{m}:{s}') }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d} {h}:{m}:{s}') }}</span>
          </template>
        </el-table-column>
      </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                @pagination="getList" />

    <!-- 查看订单信息 -->
    <el-drawer
        title="查看药监局订单"
        :visible.sync="open"
        direction="rtl"
        custom-class="desc-drawer approve-dialog view-dialog"
        append-to-body
        :show-close="true"
        :modal="false"
        :withHeader="true"
        size="40%"
    >
      <div class="drawer-content">
        <div class="item">
          <div class="label">订单号</div>
          <div class="value">{{ checkInfo.id }}</div>
        </div>
        <div class="item">
          <div class="label">用户名称</div>
          <div class="value">{{ checkInfo.userName }}</div>
        </div>
        <div class="item">
          <div class="label">金额</div>
          <div class="value">{{ checkInfo.amonut }}元</div>
        </div>
        <div class="item">
          <div class="label">支付方式</div>
          <div class="value">
            <span v-if="checkInfo.payType == 'wx'">微信</span>
            <span v-if="checkInfo.payType == 'zfb'">支付宝</span>
            <span v-if="checkInfo.payType == 'yl'">银联</span>
            <span v-if="!checkInfo.payType">-</span>
          </div>
        </div>
        <div class="item">
          <div class="label">支付状态</div>
          <div class="value">
            <span v-if="checkInfo.status == 'pay'"><el-tag type="success">已支付</el-tag></span>
            <span v-if="checkInfo.status == 'notPay'"><el-tag type="info">未支付</el-tag></span>
          </div>
        </div>
        <div class="item">
          <div class="label">支付时间</div>
          <div class="value">
            <span v-if="checkInfo.payTime">{{ checkInfo.payTime }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="item">
          <div class="label">创建时间</div>
          <div class="value">{{ checkInfo.createTime }}</div>
        </div>
        <!--        <div class="item">-->
        <!--          <div class="label">修改时间</div>-->
        <!--          <div class="value">{{ checkInfo.updateTime }}</div>-->
        <!--        </div>-->
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  listOrder} from "@/api/electronSealOrder";
export default {
  name: "Order",
  components: {},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // yjj定制-订单表格数据
      orderList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        id: undefined,
        payType: undefined,
        status: undefined,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },
      payTypeOptions: [
        {
          label: "zfb",
          value: "支付宝",
        },
        {
          label: "wx",
          value: "微信",
        },
        {
          label: "yl",
          value: "银联",
        }
      ],
      payStatusOptions: [
        {
          label: "pay",
          value: "已支付",
        },
        {
          label: "notPay",
          value: "未支付",
        }
      ],
      checkInfo:{},
      uid:""
    };
  },
  created() {
    this.uid=this.$route.query.uid;
    this.getList();
  },
  methods: {
    // 查询列表
    getList() {
      this.loading = true;
      this.queryParams.uid=this.uid;
      listOrder(this.queryParams).then(response => {
        this.orderList = response.data.rows;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        userId: undefined,
        userType: undefined,
        amonut: undefined,
        payType: undefined,
        status: "0",
        remark: undefined,
        notifyUrl: undefined,
        returnUrl: undefined,
        createTime: undefined,
        updateTime: undefined
      };
      this.resetForm("form");
    },
    // 搜索按钮
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮操
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.status = undefined;
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!=1
      this.multiple = !selection.length
    },
    parseTime(time) {
      if (time) {
        var date = new Date(time)
        var year = date.getFullYear()
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        // 拼接
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      } else {
        return ''
      }
    }
  }
};
</script>

<style lang="scss">
.app-container{
  padding: 0px 100px 40px 100px;
  background-color: #ffffff;
  min-height: 100vh;
  .kaipiaoInfo{
    padding: 20px 0 20px 0;
  }
}

.approve-dialog {
  .el-dialog__body {
    padding-top: 0;
  }
  .drawer-content {
    padding-left: 25px;
    padding-right: 25px;
    min-height: 80px;
  }
  .dialog-footer {
    margin: 25px 0;
    display: flex;
    flex-direction: row-reverse;
    margin: 25px 0;
    .el-button {
      margin-left: 25px;
    }
  }
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // margin-bottom: 15px;
    .label {
      font-weight: 700;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      width: 150px;
      text-align: right;
      padding: 10px 0;
      margin-right: 50px;
    }
    .value {
      width: calc(100% - 200px);
      img {
        border-style: none;
        /*max-width: 70%;*/
        display: block;
        margin-bottom: 20px;
      }
    }
  }
  .el-form-item {
    .el-form-item__label {
      padding-right: 50px;
    }
  }
}
.view-dialog {
  .item {
    .label {
      width: 100px;
    }
  }
}

.pager-layer {
  width: 100%;
  height: 60px;
  padding-right: 20px;
  //position: absolute;
  //right: 0;
  //bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  z-index: 99;

  .el-form-item {
    margin-right: 24px;
    margin-bottom: 16px;
    height: 32px;
    line-height: 32px;
  }
}
</style>

